import styled from "styled-components";

const FeaturesStyleWrapper = styled.section`
  padding-top: 42px;
  padding-bottom: 100px;
  background: #0d102d;

  .features_items_row {
    row-gap: 30px;
    margin-top: 60px;
  } 

  .features_title{
    width: 40%;
  }
 
`;

export default FeaturesStyleWrapper;
